module.exports = __webpack_public_path__ + "img/demo-interior-design-600x450.6de316d7.jpg";